import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Translate, I18n } from "react-redux-i18n";
import { getXsrfToken } from "../../Store/Security/Actions";
import { addToCart as addToNopCommerceCart, updateTempCart, updateTempCartKitUI } from "../../Store/Cart/Actions";
import { goNext, onFinish } from "../../Store/Wizard/Actions";
import Flickity from "react-flickity-component";

class KitProduct extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantity: 1,
            optionClicked: {},
            initialIndex: 0,
            currentImage: null,
            drag: false
        };

        this.addToCart = this.addToCart.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }

    componentDidMount() {
        // hide the wireless plan message if on wizard
        $(".wireless-plan-message").hide();
        // close the spec comparison accordions on tablet and mobile by default
        let mobileQueryWidth = window.matchMedia("(max-width: 767px)");
        this.specsCollapse(mobileQueryWidth);
        mobileQueryWidth.addListener(this.specsCollapse);
    }

    specsCollapse(width) {
        if (width.matches) {
            $("li[id^=\"accordion-list-\"]").removeClass("active");
        } else {
            $("li[id^=\"accordion-list-\"]").addClass("active");
        }
    }

    selectOption(optionClicked) {
        this.setState({ optionClicked });
    }

    addToCart() {
        const { getXsrfToken, product, wizards, goNext, onFinish, addToNopCommerceCart, updateTempCart, updateTempCartKitUI, wizard, wizardName, filter: title, kitQuantity, setCurrentId } = this.props;
        const { optionClicked } = this.state;

        if (wizard && kitQuantity === 0 || !wizard && quantity === 0) {
            alert(I18n.t("alerts.quantity"));
        } else {

            if (wizard) {
                updateTempCart({ [title]: { [product.id]: { ...product, quantity: kitQuantity, ...optionClicked } } });
                updateTempCartKitUI({ [title]: { [product.id]: { ...product, quantity: kitQuantity, ...optionClicked } } });

                setCurrentId(product.id);

                const { totalSteps, currentStep } = wizards[wizardName];

                // Wizard is finished at the second to last step because the last step is the Cart
                if (currentStep === totalSteps) {
                    onFinish(wizardName);
                } else {
                    goNext(wizardName);
                }

                window.scrollTo(0, 0);
            } else {
                getXsrfToken(({ token }) => {
                    const item = {
                        ProductId: product.id,
                        Quantity: quantity
                    };

                    if (optionClicked.productAttributeId) {
                        item.AttributeControlIds = [`product_attribute_${product.id}_${optionClicked.productAttributeId}_${optionClicked.productAttributeMapId}_${optionClicked.attributeValueId}`];
                    }

                    addToNopCommerceCart({
                        items: [item],
                        __RequestVerificationToken: token
                    });
                });
            }
        }
    }

    renderIncludes() {
        const { product } = this.props;
        // // TODO this needs to be dynamic from admin
        if (product.id === 3) {
            // panasonic
            return (
                <div className="row">
                    <div className="col-12">
                        <span className="includes-title"><Translate value="buildAKit.kitProduct.title" name="Panasonic N1" /></span>
                        <ul>
                            <li><Translate value="buildAKit.kitProduct.panasonicN1.li1" /></li>
                            <li><Translate value="buildAKit.kitProduct.panasonicN1.li2" /></li>
                            {/* <li><Translate value="buildAKit.kitProduct.panasonicN1.li3" /></li> */}
                            {/* <li><Translate value="buildAKit.kitProduct.panasonicN1.li4" /></li> */}
                        </ul>
                        <div className="includes-message"><Translate value="buildAKit.kitProduct.panasonicN1.li3" /></div>
                    </div>
                </div>
            )
        } else if (product.id === 1) {
            // zebra
            return (
                <div className="row">
                    <div className="col-12">
                        <span className="includes-title"><Translate value="buildAKit.kitProduct.title" name="Zebra TC77" /></span>
                        <ul>
                            <li><Translate value="buildAKit.kitProduct.zebraTc77.li1" /></li>
                            <li><Translate value="buildAKit.kitProduct.zebraTc77.li2" /></li>
                            {/* <li><Translate value="buildAKit.kitProduct.zebraTc77.li3" /></li> */}
                            {/* <li><Translate value="buildAKit.kitProduct.zebraTc77.li4" /></li> */}
                        </ul>
                        <div className="includes-message"><Translate value="buildAKit.kitProduct.panasonicN1.li3" /></div>
                    </div>
                </div>
            )
        }
    }

    renderSpecs() {
        const { product } = this.props;
        const productSpecs = product.productSpecifications;

        return _.map(productSpecs, (spec, specIndex) =>
            <div key={spec.id} className="col-md-12 spec-columns">
                <div className="row">
                    <div className="col-md-4 col-lg-3 spec-types">
                        <span>{spec.specificationAttributeName}</span>
                    </div>
                    <div className="col-md-8 col-lg-9 spec-values">
                        <span>{spec.valueRaw.replace(/&quot;/g, "\"")}</span>
                    </div>
                </div>
            </div>
        );
    }

    renderPictures() {
        const { product } = this.props;

        if (product.pictureModels && product.pictureModels.length > 1) {
            return _.map(product.pictureModels, picture =>
                <img key={picture.id} className="slide" alt={picture.alternateText} height={80} src={picture.fullSizeImageUrl} onMouseEnter={e => {
                    this.setState({
                        drag: e.target.offsetLeft,
                        initialIndex: _.findIndex(document.getElementsByClassName("slide"), slide => slide.className.includes("is-selected"))
                    });
                }} onClick={e => {
                    if (e.target.offsetLeft === this.state.drag) {
                        this.setState({ currentImage: picture.fullSizeImageUrl });
                    } else {
                        this.setState({ drag: false });
                    }
                }} style={{ paddingLeft: 10, paddingRight: 10 }} />
            );
        }
    }

    clickAccordionTitle(productId) {
        if ($("#accordion-list-" + productId).hasClass("active")) {
            $("#accordion-list-" + productId).removeClass("active");
        } else {
            $("#accordion-list-" + productId).addClass("active");
        }
    }

    render() {
        const { product } = this.props;
        const { initialIndex, currentImage } = this.state;

        return (
            <div className="masonry__item col-12 col-md-6 kit-product">
                <div className="row kit-product-row">
                    <div className="col-12 col-md-4">
                        <img alt="Image" src={currentImage || product.defaultPictureModel.fullSizeImageUrl} />
                    </div>
                    <div className="col-12 col-md-8 desc-column">
                        <h4><Translate value="buildAKit.kitProduct.name" name={product.name.includes("TC77") ? "Zebra TC77" : "Panasonic N1"}/></h4>
                        <h4>{product.productPrice.price}</h4>
                        <span className="kit-part-number">#{product.manufacturerPartNumber}</span>
                        <div className="kit-included-list">
                            {this.renderIncludes()}
                        </div>
                        <button type="button" className="btn btn--primary choose-device-button"
                            disabled={product.displayStockAvailability & product.stockQuantity <= 0} 
                            style={{ width: "50%" }} 
                            onClick={this.addToCart}
                            ><Translate value={product.displayStockAvailability & product.stockQuantity <= 0 ? "misc.outOfStock" : "misc.chooseDevice"} />
                        </button>
                    </div>
                </div>

                <div className="row kit-slideshow-row">
                    <div className="col-12">
                        <div className="slider">
                            <Flickity
                                className={"slides"} // default ''
                                elementType={"ul"} // default 'div'
                                options={{
                                    cellSelector: ".slide",
                                    cellAlign: "left",
                                    wrapAround: true,
                                    pageDots: true,
                                    prevNextButtons: false,
                                    autoPlay: true,
                                    // draggable: product.pictureModels.length >= 2,
                                    draggable: false,
                                    imagesLoaded: true,
                                    accessibility: true,
                                    rightToLeft: false,
                                    initialIndex: initialIndex
                                }} // takes flickity options {}
                                disableImagesLoaded={false} // default false
                                reloadOnUpdate // default false
                            >
                                {this.renderPictures()}
                            </Flickity>
                        </div>
                    </div>
                </div>

                <div className="row accordion-container">
                    <div className="col-12">
                        <ul className="accordion accordion-2">
                            <li id={`accordion-list-${product.id}`} className="active">
                                <div className="accordion__title" onClick={ () => this.clickAccordionTitle(product.id)}>
                                    <span className="h5"><Translate value="misc.specifications" name={product.name.includes("TC77") ? "Zebra TC77" : "Panasonic N1"} /></span>
                                </div>
                                <div className="accordion__content">
                                    <div className="row kit-comparison-specs">
                                        {this.renderSpecs()}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        wizards: state.wizards,
        kitQuantity: state.kitQuantity,
        tempCart: state.tempCart,
        tempCartKitUI: state.tempCartKitUI
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        addToNopCommerceCart: addToNopCommerceCart,
        updateTempCart: updateTempCart,
        updateTempCartKitUI: updateTempCartKitUI,
        goNext: goNext,
        onFinish: onFinish
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(KitProduct);